import { render, staticRenderFns } from "./DataTableVirtualScroll.vue?vue&type=template&id=d5e8bfaa&scoped=true&"
import script from "./DataTableVirtualScroll.vue?vue&type=script&setup=true&lang=js&"
export * from "./DataTableVirtualScroll.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e8bfaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
